var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.displayType === 'tag')?_c('a-tag',{attrs:{"color":_vm.color}},[_vm._v(_vm._s(_vm.$t(`ticket_status.${_vm.status}`)))]):_c('custom-tag',{attrs:{"color":_vm.color,"text":_vm.$t(`ticket_status.${_vm.status}`),"font-size":_vm.fontSize}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }